import React from 'react'
import PropTypes from 'prop-types'
import reactCSS from 'reactcss'
import tinycolor from 'tinycolor2'
import { ChromePicker } from 'react-color'

export default class ColorSelector extends React.Component {
  state = {
    displayColorPicker : false,
    color : {
      r : '241',
      g : '112',
      b : '19',
      a : '1',
    },
  };

  constructor( props ) {
    super( props )
    this.state.color = props.color || { r : 0, g : 0, b : 0, a : 1 }
  }

  handleClick = () => {
    this.setState( { displayColorPicker : !this.state.displayColorPicker } )
  };

  handleClose = () => {
    this.setState( { displayColorPicker : false } )
  };

  onChange = ( color ) => {
    this.setState( { color : color.rgb } )
    if ( this.props.onChange ) {
      color.html = tinycolor( color.rgb ).toRgbString()
      this.props.onChange( color )
    }
  };

  onChangeComplete = ( color ) => {
    if ( this.props.onChangeComplete ) {
      color.html = tinycolor( color.rgb ).toRgbString()
      this.props.onChangeComplete( color )
    }
  };

  render() {

    const styles = reactCSS( {
      default : {
        top : {
          height : '30px'
        },
        color : {
          width : '20px',
          height : '20px',
          borderRadius : '2px',
          background : `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        },
        swatch : {
          padding : '5px',
          background : '#fff',
          borderRadius : '1px',
          boxShadow : '0 0 0 1px rgba(0,0,0,.1)',
          display : 'inline-block',
          cursor : 'pointer',
          width : '30px',
          height : '30px'
        },
        popover : {
          position : 'absolute',
          zIndex : '2',
        },
        cover : {
          position : 'fixed',
          top : '0px',
          right : '0px',
          bottom : '0px',
          left : '0px',
        },
      },
    } );

    return (
      <div style={styles.top}>
        <div style={styles.swatch} onClick={this.handleClick}>
          <div style={styles.color} />
        </div>
        { this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <ChromePicker color={this.state.color} onChange={this.onChange} onChangeComplete={this.onChangeComplete} />
          </div>
        ) : null }
      </div>
    )
  }
}
